import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { MdDragHandle } from "react-icons/md";

const SortableFieldItem = ({ id, field, index, updateDisplayName }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      className="sortable-field-item"
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "8px",
      }}
    >
      {/* DRAG HANDLE ONLY */}
      <MdDragHandle
        {...listeners}
        {...attributes}
        style={{
          cursor: "grab",
          fontSize: "20px",
        }}
      />

      <div
        style={{
          flex: 1,
          minWidth: 0,
        }}
      >
        <input
          type="text"
          value={field.displayName}
          onChange={(e) => updateDisplayName(e.target.value)}
          placeholder="Display name"
          className="sortable-field-input no-drag"
          onPointerDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  );
};

export default SortableFieldItem;
